import {RootState} from "../../store/rootReducer";

export interface SideMenuState {
    isSideMenuOpen: boolean;
    cardId: string | null;
}

export const sideMenuSelector = (state: RootState): SideMenuState => ({
    isSideMenuOpen: state.ui.isSideMenuOpen,
    cardId: typeof state.review.cardId === 'string' ? state.review.cardId : null,
});